export const BODY_PART_OPTIONS = [
  { value: "chest", label: "chest" },
  { value: "back", label: "back" },
  { value: "shoulders", label: "shoulders" },
  { value: "biceps", label: "biceps" },
  { value: "triceps", label: "triceps" },
  { value: "thighs", label: "thighs" },
  { value: "hamstrings", label: "hamstrings" },
  { value: "glutes", label: "glutes" },
  { value: "calves", label: "calves" },
  { value: "abdominals", label: "abdominals" },
];

export const REP_CALCULATOR_OPTIONS = [
  { value: "Standard", label: "Standard" },
  { value: "Back/Bicep", label: "Back/Bicep" },
  { value: "Leg Press/Ext", label: "Leg Press/Ext" },
];

export const MAX_EQUATION_BASE_OPTIONS = [
  { value: "Squat", label: "Squat" },
  { value: "Bench", label: "Bench" },
  { value: "Deadlift", label: "Deadlift" },
];

export const CUSTOM_STYLES = {
  menuList: (provided) => ({
    ...provided,
    color: "#24a3f4",
    backgroundColor: "#000000",
  }),
  clearIndicator: (provided, state) => ({
    ...provided,
    cursor: "pointer",
    color: "red",
    visibility: state.selectProps.isMoreThanOne ? "visible" : "hidden",
    width: state.selectProps.isMoreThanOne ? "" : "0",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    cursor: "pointer",
    color: "white",
  }),
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#000000",
    borderWidth: "2px",
    borderRadius: "10px",
    border: state.selectProps.isValid ? "2px solid #FF0000 !important" : "",
    color: state.selectProps.isValid ? "#eb4545 !important" : "",
  }),
  groupHeading: (provided) => ({
    ...provided,
    color: "#24a3f4",
    backgroundColor: "#000000",
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#000000",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "white",
    backgroundColor: "#000000",
  }),
  multiValueRemove: (provided, state) => ({
    ...provided,
    cursor: "pointer",
    float: "right",
    color: "red",
    visibility: !state.selectProps.isUnspecified ? "visible" : "hidden",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "white",
  }),
  container: (provided) => ({
    ...provided,
    color: "white",
    minWidth: "40%",
  }),
  singleValue: (provided) => ({
    ...provided,
    backgroundColor: "#000000",
    color: "white",
  }),
};

export const INITIAL_VALUES = {
  name: "",
  body_parts: [],
  rep_calculator: REP_CALCULATOR_OPTIONS[0].value,
  max_equation_base: MAX_EQUATION_BASE_OPTIONS[0].value,
  max_equation_multiplier: "",
  video_tutorial_url: "",
};

export const EXCERCISES_PREVIEW_COUNT = 20;

export const EXERCISES_MULTIPLIER = {
  MAX: 10,
  MIN: 0.1,
};

export const EXERCISE_TYPES = {
  GLOBAL: "global",
  SYSTEM_REG: /^globalSystem[a-zA-Z]*$/,
};

export const MESSAGES = {
  NO_NEW_DATA: "you haven't added any new data",
  PICK_BODY_PART: "you need to pick a single body part",
  SHOULD_NOT_BE_EMPTY: "field should not be empty",
  SHOULD_BE_NUMBER: "value should be a number",
  SHOULD_BE_GREATER_THAN_0: "value should be greater than 0",
  SHOULD_BE_LESS_THAN_10: "value should be less than 10",
  LINK_IS_INCORRECT: "link is incorrect",
  ERROR: "error",
};

export const BODY_PARTS = "body_parts";
export const VIDEO_TUTORIAL_URL = "video_tutorial_url";
export const VIDEO_TUTORIAL_URL_TO_SET = "video_tutorial_url_to_set";
export const UNSPECIFIED = "unspecified";

export const MAX_REPS = {
  Standard: 30,
  "Back/Bicep": 30,
  "Leg Press/Ext": 50,
};
